import type {CoreConfig, DAL, ExtensionAPI} from '@wix/document-manager-core'
import type {
    CompRef,
    CoreExportFormat,
    Pointer,
    Pointers,
    RawComponentExport,
    WmlExportFormat
} from '@wix/document-services-types'
import type {ImportExportExtensionApi} from '../../import-export/importExportExtension'
import {buildPlaceholderStructure} from '../../import-export/json/utils'
import {reuseIds} from './reuseIds'
import type {DocumentFSPageUpdate} from '@wix/anyide-cli-types'
import {convertCoreToWmlComponentExport} from '../../import-export/formatConverter'

const getAllPointersOfPage = ({id}: CompRef, pointers: Pointers): Pointer[] => {
    const pageDataPointer: Pointer = pointers.data.getDataItem(id)
    return pointers.page.getAllPointersByPage(id).concat(pageDataPointer)
}

export const importPage = async (
    pagePointer: CompRef,
    pageData: DocumentFSPageUpdate,
    extensionAPI: ExtensionAPI,
    dal: DAL,
    pointers: Pointers,
    {schemaService}: CoreConfig
): Promise<void> => {
    const {importExport} = extensionAPI as ImportExportExtensionApi

    if (pageData === null) {
        const allItemsOfPage: Pointer[] = getAllPointersOfPage(pagePointer, pointers)
        allItemsOfPage.forEach((ptr: Pointer) => dal.remove(ptr))
        return
    }

    const rawComponentExport: RawComponentExport = await importExport.wml.convertWmlToRawComponentExport(pageData.data)

    if (!dal.has(pagePointer)) {
        const pagePlaceholderStructure = buildPlaceholderStructure(pagePointer, pagePointer)
        dal.set(pagePointer, pagePlaceholderStructure)

        const mobilePointer = pointers.structure.getMobilePointer(pagePointer)
        dal.set(mobilePointer, pagePlaceholderStructure)
    }
    reuseIds(rawComponentExport, schemaService)
    importExport.pages.replace(pagePointer, rawComponentExport, {componentFeatures: 'All'})
}

export const exportPage = (pagePointer: CompRef, extensionAPI: ExtensionAPI, dal: DAL): WmlExportFormat | null => {
    if (!dal.has(pagePointer)) {
        return null
    }

    const {importExport} = extensionAPI as ImportExportExtensionApi
    const coreExport: CoreExportFormat = importExport.core.exportPage(pagePointer, {componentFeatures: 'All'})
    delete coreExport.dependencies

    return convertCoreToWmlComponentExport(coreExport)
}
